import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

type GiftCardAmountSelectionProps = {
  amounts: number[]
  activeAmount: number
  onNewAmount: (amount: number) => void
  minAmount: number
  maxAmount: number
}

export const GiftCardAmountSelection: React.FC<
  GiftCardAmountSelectionProps
> = ({ amounts, activeAmount, onNewAmount, minAmount, maxAmount }) => {
  const onStepChange = (operation: '-' | '+') => {
    const amountStep = +operation.concat(`5`)
    const newAmount = activeAmount + amountStep
    onNewAmount(
      newAmount >= minAmount && newAmount <= maxAmount
        ? newAmount
        : activeAmount,
    )
  }

  const onDecrease = () => onStepChange('-')
  const onIncrease = () => onStepChange('+')

  return (
    <div
      style={{
        padding: '0 1rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '100dvw',
      }}
    >
      <Text
        type="largeBody"
        content="Select Amount"
        alignment="center"
        style={{ fontWeight: 700 }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '80%',
          marginTop: '1rem',
        }}
      >
        <div
          style={{ width: '50px', cursor: 'pointer', userSelect: 'none' }}
          onClick={onDecrease}
        >
          <Text
            type="heroTitle"
            content="-"
            alignment="center"
            color="primaryBody"
            style={{ fontWeight: 500, fontSize: '3rem' }}
          />
        </div>
        <div
          style={{
            flexGrow: 1,
            margin: '0 12px',
            paddingBottom: '0.5rem',
            borderBottom: '3px solid #dedede',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            type="heroTitle"
            content="$"
            alignment="center"
            color="primaryBody"
            style={{
              fontWeight: 400,
              fontSize: '2rem',
              marginRight: '0.25rem',
            }}
          />
          <Text
            type="heroTitle"
            content={activeAmount}
            alignment="center"
            style={{ fontWeight: 700, fontSize: '3.5rem' }}
          />
        </div>
        <div
          style={{ width: '50px', cursor: 'pointer', userSelect: 'none' }}
          onClick={onIncrease}
        >
          <Text
            type="heroTitle"
            content="+"
            alignment="center"
            color="primaryBody"
            style={{ fontWeight: 500, fontSize: '3rem' }}
          />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          padding: '1rem',
          width: '100%',
        }}
      >
        {amounts.map((amount, index) => {
          return (
            <div
              key={index}
              onClick={() => onNewAmount(amount)}
              style={{
                padding: '0.5rem 1rem',
                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
                backgroundColor: activeAmount === amount ? '#404040' : '#fff',
                borderRadius: '12px',
                userSelect: 'none',
                cursor: 'pointer',
              }}
            >
              <Text
                type="caption"
                content={`$${amount}`}
                alignment="center"
                color={activeAmount === amount ? 'inverseBody' : 'primaryBody'}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
